import React from 'react';
import Select, { Props as RSProps } from 'react-select';

export type Option<T = any> = { value: T; label: string };

type BaseSelectProps<T = any> = Omit<RSProps<Option<T>, boolean>, 'options'> & {
  options: Option<T>[];
  isMulti?: boolean;
};

export const defaultSelectStyles: RSProps<Option<any>, boolean>['styles'] = {
  control: (provided, state) => ({
    ...provided,
    minHeight: 'calc(1.5em + 0.75rem)',
    boxShadow: 'none',
    borderColor: state.isFocused ? '#FF0000' : provided.borderColor,
    '&:hover': {
      borderColor: state.isFocused ? '#FF0000' : provided.borderColor,
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'inherit',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? '#FF0000' 
      : state.isFocused 
      ? '#FF0000' 
      : provided.backgroundColor,
    color: state.isSelected || state.isFocused ? '#fff' : provided.color,
    cursor: 'pointer',
    '&:active': {
      backgroundColor: '#FF0000',
    },
  }),
};

const BaseSelect = <T,>({ options, isMulti = false, styles, ...rest }: BaseSelectProps<T>) => {
  const mergedStyles = styles ? { ...defaultSelectStyles, ...styles } : defaultSelectStyles;

  return (
    <Select<Option<T>, boolean>
      options={options}
      isMulti={isMulti}
      classNamePrefix="react-select"
      styles={mergedStyles as any}
      {...(rest as any)}
    />
  );
};

export default BaseSelect;